import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { INVENTORIES_READ } from '~/components/routes/inventories/permissions'
import { StoreDaySheet } from '~/components/routes/inventories/store-day-sheet'
import { withRoutePermissions } from '~/utils/rbac'

/** Panneau latéral d'une boutique — route enfant pour garder l'URL partageable (kanban #823). */
export const Route = createFileRoute('/_authenticated/inventories/$storeId')({
  staticData: { permission: INVENTORIES_READ },
  component: RouteComponent,
  params: {
    parse: z.object({ storeId: z.coerce.number().int().positive() }).parse,
  },
})
withRoutePermissions(Route)

function RouteComponent() {
  const { storeId } = Route.useParams()

  return <StoreDaySheet storeId={storeId} />
}
